import React, { useCallback } from "react";
/*import Cookies from "universal-cookie";*/
import APIService from "../services/Api";
import {
  CashierConfig,
  CashierUser,
  CashierWelcome,
  IAccountForm,
  IBlog,
  IDeposit,
  INotification,
  Proccesor,
  UserOnline,
} from "../types";
import { UseAuth } from "./AuthContext";
import constate from "constate";
import Decimal from "decimal.js";
/*const cookies = new Cookies();*/

type AppState = {
  deposits: IDeposit[];
  bankAccounts: IAccountForm[];
  processors: Proccesor[];
  loading: boolean;
  cashierCoins: number | Decimal;
  frozenCoins: number | Decimal;
  adminHouseCoins: number | Decimal;
  cashierConfig: CashierConfig | undefined;
  usersOnline: UserOnline[];
  currentDollar: string;
  currentDollarFiat: string;
  cashierFather: CashierUser | undefined;
  notifications: INotification[];
  adminNotifications: INotification[];
  cashierWelcome: CashierWelcome;
  blogs: IBlog[];
  news: IBlog[];
  showRegisterPopup: boolean;
  showMenuMovil: boolean;
  goLogin: boolean;
};
const initialState: AppState = {
  deposits: [],
  processors: [],
  bankAccounts: [],
  usersOnline: [],
  notifications: [],
  cashierWelcome: {
    id: "",
    processors: true,
    accounts: true,
    ranges: true,
    schedule: true,
    hoursToPay: true,
    coinsInfo: true,
    cashierConfigId: "",
  },
  cashierFather: undefined,
  adminNotifications: [],
  cashierCoins: 0,
  frozenCoins: 0,
  adminHouseCoins: 0,
  cashierConfig: undefined,
  blogs: [],
  news: [],
  currentDollar: "0",
  currentDollarFiat: "usd",
  loading: false,
  showRegisterPopup: false,
  showMenuMovil: false,
  goLogin: false,
};

type Action =
  | {
      type: "SET_DEPOSITS";
      payload: IDeposit[];
    }
  | {
      type: "SET_BANK_ACCOUNTS";
      payload: IAccountForm[];
    }
  | {
      type: "SET_PROCESSORS";
      payload: Proccesor[];
    }
  | {
      type: "SET_USERS_ONLINE";
      payload: UserOnline[];
    }
  | {
      type: "SET_NOTIFICATIONS";
      payload: INotification[];
    }
  | {
      type: "SET_ADMIN_NOTIFICATIONS";
      payload: INotification[];
    }
  | {
      type: "SET_LOADING";
      payload: boolean;
    }
    | {
      type: "SET_CURRENT_DOLLAR";
      payload: string;
    }
    | {
      type: "SET_CURRENT_DOLLAR_FIAT";
      payload: string;
    }    
  | {
      type: "SET_BLOGS";
      payload: IBlog[];
    }
  | {
      type: "SET_NEWS";
      payload: IBlog[];
    }
  | {
      type: "SET_CASHIER_COINS";
      payload: number;
    }
  | {
      type: "SET_FROZEN_COINS";
      payload: number;
    }
  | {
      type: "SET_ADMIN_HOUSE_COINS";
      payload: number;
    }
  | {
      type: "SET_CASHIER_CONFIG";
      payload: CashierConfig;
    }
  | {
      type: "SET_CASHIER_WELCOME";
      payload: CashierWelcome;
    }
  | {
      type: "SET_CASHIER_FATHER";
      payload: CashierUser | undefined;
    }
  | {
      type: "SET_SHOW_REGISTER_POPUP";
      payload: boolean;
    }
  | {
      type: "SET_SHOW_MENU_MOVIL";
      payload: boolean;
    }
  | {
      type: "SET_GO_LOGIN";
      payload: boolean;
    };

const reducer = (state: AppState, action: Action) => {
  switch (action.type) {
    case "SET_DEPOSITS":
      return { ...state, deposits: action.payload };
    case "SET_BANK_ACCOUNTS":
      return { ...state, bankAccounts: action.payload };
    case "SET_PROCESSORS":
      return { ...state, processors: action.payload };
    case "SET_NOTIFICATIONS":
      return { ...state, notifications: action.payload };
    case "SET_ADMIN_NOTIFICATIONS":
      return { ...state, adminNotifications: action.payload };
    case "SET_USERS_ONLINE":
      return { ...state, usersOnline: action.payload };
      case "SET_CURRENT_DOLLAR":
        return { ...state, currentDollar: action.payload };
        case "SET_CURRENT_DOLLAR_FIAT":
          return { ...state, currentDollarFiat: action.payload };        
    case "SET_BLOGS":
      return { ...state, blogs: action.payload };
    case "SET_NEWS":
      return { ...state, news: action.payload };
    case "SET_CASHIER_COINS":
      return { ...state, cashierCoins: action.payload };
    case "SET_FROZEN_COINS":
      return { ...state, frozenCoins: action.payload };
    case "SET_ADMIN_HOUSE_COINS":
      return { ...state, adminHouseCoins: action.payload };
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_CASHIER_CONFIG":
      return { ...state, cashierConfig: action.payload };
    case "SET_CASHIER_WELCOME":
      return { ...state, cashierWelcome: action.payload };
    case "SET_CASHIER_FATHER":
      return { ...state, cashierFather: action.payload };
    case "SET_SHOW_REGISTER_POPUP":
      return { ...state, showRegisterPopup: action.payload };
    case "SET_SHOW_MENU_MOVIL":
      return { ...state, showMenuMovil: action.payload };
    case "SET_GO_LOGIN":
      return { ...state, goLogin: action.payload };
  }
};

const useAppState = () => {
  const { user } = UseAuth();
  const [state, dispatch] = React.useReducer(reducer, initialState);

  const fetchBankAccounts = async () => {
    dispatch({ type: "SET_LOADING", payload: true });
    const list = await APIService.accountList({ user: user?.id || "" });
    const response = list?.data?.data?.accounts as IAccountForm[];
    dispatch({ type: "SET_BANK_ACCOUNTS", payload: response });
    dispatch({ type: "SET_LOADING", payload: false });
    //setLoadingList(false);
  };

  const fetchDeposits = async () => {
    dispatch({ type: "SET_LOADING", payload: true });
    const list = await APIService.derivListDeposit({ user: user?.id || "" });
    const response = list?.data?.data?.accounts;
    dispatch({ type: "SET_DEPOSITS", payload: response });
    dispatch({ type: "SET_LOADING", payload: false });
  };

  const fetchBlogs = async () => {
    dispatch({ type: "SET_LOADING", payload: true });
    const service = await APIService.webBlogList({ type: "blog" });

    if (service.data.status) {
      dispatch({ type: "SET_BLOGS", payload: service.data.data.post });
    }
    dispatch({ type: "SET_LOADING", payload: false });
  };
  const fetchNews = async () => {
    dispatch({ type: "SET_LOADING", payload: true });
    const service = await APIService.webBlogList({ type: "notice" });

    if (service.data.status) {
      dispatch({ type: "SET_NEWS", payload: service.data.data.post });
    }
    dispatch({ type: "SET_LOADING", payload: false });
  };

  const fetchProccesors = useCallback(async () => {
    dispatch({ type: "SET_LOADING", payload: true });
    const list = await APIService.processorList({});
    const response = list?.data?.data?.list as Proccesor[];
    dispatch({ type: "SET_PROCESSORS", payload: response });
    dispatch({ type: "SET_LOADING", payload: false });
  }, [dispatch]);

  const fetchCashierCoins = useCallback(
    async (cashierId: string) => {
      dispatch({ type: "SET_LOADING", payload: true });
      const list = await APIService.CashierGetCoins({ cashierId: cashierId });
      const response = list?.data?.data?.coins as number;
      const frozenCoins = list?.data?.data?.frozenCoins as number;
      dispatch({ type: "SET_CASHIER_COINS", payload: response || 0 });
      dispatch({ type: "SET_FROZEN_COINS", payload: frozenCoins || 0 });
      dispatch({ type: "SET_LOADING", payload: false });
    },
    [dispatch]
  );

  const fetchAdminHouseCoins = useCallback(async () => {
    dispatch({ type: "SET_LOADING", payload: true });
    const response = await APIService.AdminGetHouseCoins({});
    const coin = response?.data?.data?.houseCoins?.amount || 0;
    dispatch({ type: "SET_ADMIN_HOUSE_COINS", payload: coin || 0 });
    dispatch({ type: "SET_LOADING", payload: false });
  }, [dispatch]);

  const fetchCashierConfig = useCallback(
    async (cashierId: string) => {
      if ((cashierId?.length || 0) > 0) {
        dispatch({ type: "SET_LOADING", payload: true });
        const list = await APIService.CashierConfigGet({ cashierId });
        const response = list?.data?.data?.cashierConfig as CashierConfig;
        dispatch({ type: "SET_CASHIER_CONFIG", payload: response });
        dispatch({ type: "SET_LOADING", payload: false });
      }
    },
    [dispatch]
  );

  const fetchCashierWelcome = useCallback(
    async (cashierId: string) => {
      if (cashierId.length > 0) {
        dispatch({ type: "SET_LOADING", payload: true });
        const list = await APIService.CashierWelcomeGet({ id: cashierId });
        const response = list?.data?.data?.cashierWelcome as CashierWelcome;
        console.log('respues cashierWelcome', response)
        dispatch({ type: "SET_CASHIER_WELCOME", payload: response });
        dispatch({ type: "SET_LOADING", payload: false });
      }
    },
    [dispatch]
  );

  const fetchCashierFather = useCallback(
    async (userId: string) => {
      dispatch({ type: "SET_LOADING", payload: true });
      const res = await APIService.userFindMyCashier({ userId: userId });
      const cashier = res?.data?.data?.cashier;
      dispatch({ type: "SET_CASHIER_FATHER", payload: cashier });
      dispatch({ type: "SET_LOADING", payload: false });
    },
    [dispatch]
  );

  const adminFetchUsersOnline = useCallback(async () => {
    dispatch({ type: "SET_LOADING", payload: true });
    const list = await APIService.listUserChat({});
    const response = list?.data?.data?.lastChats as UserOnline[];
    dispatch({ type: "SET_USERS_ONLINE", payload: response });
    dispatch({ type: "SET_LOADING", payload: false });
  }, [dispatch]);

  const updateBankAccounts = useCallback(
    async (bankAccounts: IAccountForm[]) => {
      dispatch({ type: "SET_LOADING", payload: true });
      dispatch({ type: "SET_BANK_ACCOUNTS", payload: bankAccounts });
      dispatch({ type: "SET_LOADING", payload: false });
    },
    [dispatch]
  );

  const updateDeposits = useCallback(
    async (deposits: IDeposit[]) => {
      dispatch({ type: "SET_LOADING", payload: true });
      dispatch({ type: "SET_DEPOSITS", payload: deposits });
      dispatch({ type: "SET_LOADING", payload: false });
    },
    [dispatch]
  );

  const updateProcessors = useCallback(
    async (processors: Proccesor[]) => {
      dispatch({ type: "SET_LOADING", payload: true });
      dispatch({ type: "SET_PROCESSORS", payload: processors });
      dispatch({ type: "SET_LOADING", payload: false });
    },
    [dispatch]
  );

  const fetchCurrentDollar = useCallback(async () => {
    dispatch({ type: "SET_LOADING", payload: true });
    const dolar = await APIService.fetchCurrentDollar({});
    console.log('RESPONSE DE DOALR ES ',dolar)
    const response = dolar?.data?.data?.dollar || 0;
    const fiat = dolar?.data?.data?.fiat || "usd"
    console.log('dollar es ',response)
    console.log('fiat es ',fiat)
    dispatch({ type: "SET_CURRENT_DOLLAR", payload: response });
    dispatch({ type: "SET_CURRENT_DOLLAR_FIAT", payload: fiat });
    dispatch({ type: "SET_LOADING", payload: false });
  }, [dispatch]);

  const setNotifications = useCallback(
    async (notifications: INotification[]) => {
      dispatch({ type: "SET_NOTIFICATIONS", payload: notifications });
    },
    [dispatch]
  );

  const setAdminNotifications = useCallback(
    async (adminNotifications: INotification[]) => {
      dispatch({
        type: "SET_ADMIN_NOTIFICATIONS",
        payload: adminNotifications,
      });
    },
    [dispatch]
  );

  const setCashierConfig = useCallback(
    async (cashierConfig: CashierConfig) => {
      dispatch({ type: "SET_CASHIER_CONFIG", payload: cashierConfig });
    },
    [dispatch]
  );

  const setCashierWelcome = useCallback(
    async (cashierWelcome: CashierWelcome) => {
      dispatch({ type: "SET_CASHIER_WELCOME", payload: cashierWelcome });
    },
    [dispatch]
  );

  const setCashierFather = useCallback(
    async (cashierFather: CashierUser | undefined) => {
      dispatch({ type: "SET_CASHIER_FATHER", payload: cashierFather });
    },
    [dispatch]
  );

 
  const setShowRegisterPopup = useCallback(
    async (t: boolean) => {
      dispatch({ type: "SET_SHOW_REGISTER_POPUP", payload: t });
    },
    [dispatch]
  );

  const setShowMenuMovil = useCallback(
    async (show: boolean) => {
      dispatch({ type: "SET_SHOW_MENU_MOVIL", payload: show });
    },
    [dispatch]
  );

  const setGoLogin = useCallback(
    async (value: boolean) => {
      dispatch({ type: "SET_GO_LOGIN", payload: value });
    },
    [dispatch]
  );

  return {
    ...state,
    fetchBankAccounts,
    fetchDeposits,
    fetchProccesors,
    fetchCashierCoins,
    fetchAdminHouseCoins,
    fetchCashierConfig,
    fetchCurrentDollar,
    fetchCashierWelcome,
    fetchCashierFather,
    adminFetchUsersOnline,
    fetchBlogs,
    fetchNews,
    updateBankAccounts,
    updateProcessors,
    updateDeposits,
    setNotifications,
    setAdminNotifications,
    setCashierConfig,
    setCashierWelcome,
    setCashierFather,
    setShowRegisterPopup,
    setShowMenuMovil,
    setGoLogin,
  };
};

const [AppStateProvider, useAppStateContext] = constate(useAppState);

export { AppStateProvider, useAppStateContext };
